var languageSwitchers = [].slice.call(document.querySelectorAll('.lang-button'));

languageSwitchers.forEach(function(switcher) {
	switcher.addEventListener('click', function(e) {
		var parent = this.parentNode,
			list = parent.querySelector('ul');

		closeDropDown(parent, e);

		parent.classList.toggle('open');

		Velocity(list, (window.getComputedStyle(list).display == 'block' ? 'fadeOut' : 'fadeIn'), {duration: 300});
	});

	if(typeof Cookie.get('googtrans')!=='undefined') {
		switcher.innerHTML = Cookie.get('language');
	}
});

body.addEventListener('click', function(e) {
	closeDropDown(this, e);
});

function closeDropDown(el, e) {
	var open = document.querySelector('.language-picker-container.open');

	if(open) {
		if(open !== el && !open.contains(e.target)) {
			open.classList.remove('open');
			Velocity(open.querySelector('ul'), 'fadeOut', {duration: 300});
		}
	}
}

var languages = [].slice.call(document.querySelectorAll('.site-translate'));

if(!Cookie.get('language')) {

	//No cookie, so cookie added
	// Cookie.set('language', 'en');
	

} else {

	// Cookie.set('language', 'en');

	if(window.location.pathname.indexOf('/es') < 0) {
		Cookie.set('language', 'en');

	} 
	
	// window.location.href = window.location.hostname + '/' + Cookie.get('language') !== lang;
}

languages.forEach(function(language) {
	language.addEventListener('click', function(e) {
		e.preventDefault();
		console.log(this.href.split('#')[1]);
		var lang = this.classList.contains('site-translate') ? this.href.split('#')[1] : this.getAttribute('hreflang');
		console.log(lang);

			Cookie.set('language', this.getAttribute('hreflang'));

			googTransHandle(false, lang);

			window.location.reload();

		

	});
});

let resetButton  = [].slice.call(document.querySelectorAll('a[data-value=English]'));

if(resetButton.length > 0 ) {

	resetButton[0].addEventListener('click', function(e) {
		
		Cookie.remove('language');
		Cookie.remove('googtrans');

	});
}

function googTransHandle(domain, lang) {
	if(!domain) {
		if(typeof Cookie.get('googtrans')!=='undefined') {
			Cookie.remove('language');
			Cookie.remove('googtrans');
		}
		if(lang!=='en') {
			Cookie.set('language', lang);
			Cookie.set('googtrans', '/en/'+lang);
		} 
	} else {
		if(typeof Cookie.get('googtrans', {domain: domain})!=='undefined') {
			Cookie.remove('language', {domain: domain});
			Cookie.remove('googtrans', {domain: domain});
		}
		if(lang!=='en') {
			Cookie.set('language', lang, {domain: domain});
			Cookie.set('googtrans', '/en/'+lang, {domain: domain});
		}
	}
}